import { apiClient } from './client.js';
import type { PaypalApprovalDetails, PaypalCheckoutKind } from '../models/paypal.js';

// This read never captures or activates the checkout.
export function getPaypalApprovalDetails(kind: PaypalCheckoutKind, id: string, options?: { signal?: AbortSignal }): Promise<PaypalApprovalDetails> {
  const resource = kind === 'order' ? 'orders' : 'subscriptions';
  return apiClient.get<PaypalApprovalDetails>(
    `/donate/v1/paypal/${resource}/${encodeURIComponent(id)}/approval`,
    { timeout: 30_000, withAuth: false, signal: options?.signal },
  );
}
